import { useHistoryDrilldown } from '@src/packages/dashboard/components/ReportSummary/hooks/useHistoryDrilldown';
import type {
  ExecutionsHistoryRouteQuery,
  RouteDrilldownSectionData,
  RouteDrilldownTarget,
} from '@src/models/interfaces/executionsHistoryDashboard.interface';
import ExecutionsHistoryDashboardService from '@src/services/ExecutionsHistoryDashboardService';

const loadRouteDrilldown = (
  service: ExecutionsHistoryDashboardService,
  request: Parameters<ExecutionsHistoryDashboardService['getRouteDrilldown']>[0],
) => service.getRouteDrilldown(request);

export const useRouteHistoryDrilldown = (
  query: ExecutionsHistoryRouteQuery | undefined,
  target: RouteDrilldownTarget | null,
  search: string,
  page: number,
) =>
  useHistoryDrilldown<ExecutionsHistoryRouteQuery, RouteDrilldownTarget, RouteDrilldownSectionData>(
    query,
    target,
    search,
    page,
    { loadDrilldown: loadRouteDrilldown },
  );
